module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-home"
  }, [(_vm.isPc) ? _c('div', {
    staticClass: "diandian-pc"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "dh-banner-pc",
    staticClass: "dh-banner-pc"
  }, [_c('div', {
    staticClass: "dh-slider-background"
  }, [_c('div', {
    staticClass: "dh-bg-1",
    class: {
      'anima_slider': _vm.isDs_1_bg, 'anima_slider_reverse': _vm.isDs_1_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-2",
    class: {
      'anima_slider': _vm.isDs_2_bg, 'anima_slider_reverse': _vm.isDs_2_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-3",
    class: {
      'anima_slider': _vm.isDs_3_bg, 'anima_slider_reverse': _vm.isDs_3_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-4",
    class: {
      'anima_slider': _vm.isDs_4_bg, 'anima_slider_reverse': _vm.isDs_4_bg_rs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-bg-5",
    class: {
      'anima_slider': _vm.isDs_5_bg, 'anima_slider_reverse': _vm.isDs_5_bg_rs
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_1_bg),
      expression: "isDs_1_bg"
    }],
    staticClass: "dh-slider dh-slider-1"
  }, [_c('div', {
    staticClass: "ss-main",
    attrs: {
      "id": "scene"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_1, 'bounceOutUp': !_vm.isDs_1
    }
  }, [_c('h1', {}, [_vm._v("点点")]), _vm._v(" "), _c('h2', [_vm._v("一站式生活消费金融神器")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])]), _vm._v(" "), _c('div', {
    staticClass: "slide-phone anim_dh_phone",
    class: {
      'bounceInUp': _vm.isDs_1, 'bounceOutUp2': !_vm.isDs_1
    },
    attrs: {
      "id": "scene-sp-1"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.45"
    }
  }, [_c('img', {
    staticClass: "sp-1",
    class: {
      'anima_round1': _vm.isDs_1, 'anima_round1_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "82",
      "src": require("../assets/images/symbols-1.png")
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('img', {
    staticClass: "sp-2",
    class: {
      'anima_round2': _vm.isDs_1, 'anima_round2_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "68",
      "src": require("../assets/images/symbols-2.png")
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('img', {
    staticClass: "sp-3",
    class: {
      'anima_round3': _vm.isDs_1, 'anima_round3_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "88",
      "src": require("../assets/images/symbols-3.png")
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.125"
    }
  }, [_c('img', {
    staticClass: "sp-4",
    class: {
      'anima_phone': _vm.isDs_1, 'anima_phone_reverse': !_vm.isDs_1
    },
    attrs: {
      "alt": "点点-Banner",
      "width": "258",
      "src": require("../assets/images/symbols-reflections.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_2_bg),
      expression: "isDs_2_bg"
    }],
    staticClass: "dh-slider dh-slider-2"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_2"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_2, 'bounceOutUp': !_vm.isDs_2
    }
  }, [_c('h1', {}, [_vm._v("借钱还卡")]), _vm._v(" "), _c('h2', [_vm._v("还逾期,一键帮还信用卡")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "slide-card",
    class: {
      'bounceInUp': _vm.isDs_2, 'bounceOutUp2': !_vm.isDs_2
    },
    attrs: {
      "id": "scene-sp-2"
    }
  }, [_c('div', [_c('div', {
    staticClass: "q-dd-1",
    class: {
      'anima_q_dd_2': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "q-dd-2",
    class: {
      'anima_q_dd_1': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.35"
    }
  }, [_c('div', {
    staticClass: "r-c-1",
    class: {
      'zoomIn': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.15"
    }
  }, [_c('div', {
    staticClass: "r-c-2",
    class: {
      'zoomIn': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.25"
    }
  }, [_c('div', {
    staticClass: "hb hb-1",
    class: {
      'anima_hb_1': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "hb hb-2",
    class: {
      'anima_hb_2': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "hb hb-3",
    class: {
      'anima_hb_3': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.5"
    }
  }, [_c('div', {
    staticClass: "hb hb-4",
    class: {
      'anima_hb_4': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.25"
    }
  }, [_c('div', {
    staticClass: "hb hb-5",
    class: {
      'anima_hb_5': _vm.isDs_2
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.45"
    }
  }, [_c('div', {
    staticClass: "symbols-card",
    class: {
      'anima_card': _vm.isDs_2
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_3_bg),
      expression: "isDs_3_bg"
    }],
    staticClass: "dh-slider dh-slider-3"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_3"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_3, 'bounceOutUp': !_vm.isDs_3
    }
  }, [_c('h1', {}, [_vm._v("借一点")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "jk-main banner-box",
    class: {
      'bounceInUp': _vm.isDs_3, 'bounceOutUp2': !_vm.isDs_3
    },
    attrs: {
      "id": "scene-sp-3"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.1"
    }
  }, [_c('div', {
    staticClass: "jk jk-round-bg",
    class: {
      'jk_round': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "jk jk-icon",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-1",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-2",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "jk jk-r-3",
    class: {
      'zoomIn': _vm.isDs_3
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_4_bg),
      expression: "isDs_4_bg"
    }],
    staticClass: "dh-slider dh-slider-4"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_4"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_4, 'bounceOutUp': !_vm.isDs_4
    }
  }, [_c('h1', {}, [_vm._v("点点闪付")]), _vm._v(" "), _c('h2', [_vm._v("点点闪付,买单超舒服")]), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "banner-box",
    class: {
      'bounceInUp': _vm.isDs_4, 'bounceOutUp2': !_vm.isDs_4
    },
    attrs: {
      "id": "scene-sp-4"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDs_5_bg),
      expression: "isDs_5_bg"
    }],
    staticClass: "dh-slider dh-slider-5"
  }, [_c('div', {
    staticClass: "ss-main"
  }, [_c('div', {
    staticClass: "h-auto zindex-s",
    attrs: {
      "id": "scene_5"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "slide-text",
    class: {
      'fadeInUp': _vm.isDs_5, 'bounceOutUp': !_vm.isDs_5
    }
  }, [_c('h1', {}, [_vm._v("生活所需 一站完成")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Diandian Finance")]), _vm._v(" "), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "banner-box",
    class: {
      'bounceInUp': _vm.isDs_5, 'bounceOutUp2': !_vm.isDs_5
    },
    attrs: {
      "id": "scene-sp-5"
    }
  }, [_c('div', {
    staticClass: "lw box-bg",
    attrs: {
      "data-depth": "0.1"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "dh-pagination"
  }, _vm._l((_vm.page), function(item, index) {
    return _c('div', {
      staticClass: "dh-page",
      on: {
        "click": function($event) {
          return _vm.paginationHandle($event, index)
        }
      }
    }, [_c('span', {
      staticClass: "m-page"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dh-life"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "dh-sm-download"
  }, [_c('div', {
    staticClass: "dd-sd",
    on: {
      "mouseover": _vm.dsMouseOverHandle,
      "mouseout": _vm.dsMouseOutHandle
    }
  }, [_c('div', {
    staticClass: "dd-sd-radio",
    class: {
      'dsRadio': _vm.isDsRadio
    }
  }), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('p', [_vm._v("下载点点手机客户端，即刻开启品质生活")]), _vm._v(" "), (_vm.isQrcode) ? _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "ra"
  }), _vm._v(" "), _vm._m(11)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hz-phone"
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "box"
    }
  })]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "diandinan-mobile"
  }, [_c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    staticClass: "nav-main"
  }, [_c('div', {
    staticClass: "dd-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-download",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_c('i'), _vm._v("下载点点\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/images/mobile/banner-phone1.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/images/mobile/banner-phone2.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/images/mobile/banner-phone3.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/images/mobile/banner-phone4.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    attrs: {
      "src": require("../assets/images/mobile/banner-phone5.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination my-swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-nav"
  }, [_c('div', {
    staticClass: "nav-main"
  }, [_c('div', {
    staticClass: "dd-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-download"
  }, [_c('i'), _vm._v("下载点点\n                    "), _c('div', {
    staticClass: "nav-qrcode"
  }, [_c('div', {
    staticClass: "qrcode-main"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("额度高至20万,"), _c('br'), _vm._v("一秒审核3秒放款")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "pos pos-hb-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "pos pos-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.5"
    }
  }, [_c('div', {
    staticClass: "pos pos-r-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "pos pos-r-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("话费充值／加油卡／"), _c('br'), _vm._v("水电煤／游戏充值")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.3"
    }
  }, [_c('div', {
    staticClass: "lw box-liwu"
  }, [_c('div', {
    staticClass: "bl-h"
  }), _vm._v(" "), _c('div', {
    staticClass: "scene_6",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "scene_6"
    }
  }, [_c('div', {
    attrs: {
      "data-depth": "0.2"
    }
  }, [_c('div', {
    staticClass: "bl-l"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bl-q"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-depth": "0.4"
    }
  }, [_c('div', {
    staticClass: "pos pos-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("DIANDIAN")]), _vm._v(" "), _c('p', [_vm._v("点点")]), _vm._v(" "), _c('span', [_vm._v("让生活，好一点")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("\n                        扫码下载"), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-container"
  }, [_c('div', {
    staticClass: "qrcode-main"
  }, [_c('div', {
    staticClass: "qrcode"
  })]), _vm._v(" "), _c('span', [_vm._v("扫码下载点点手机客户端")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-about"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', [_vm._v("关于点点")])]), _vm._v(" "), _c('div', {
    staticClass: "about-main"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("智能生活")]), _vm._v(" "), _c('p', [_vm._v("国内领先的智能生活金融服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("综合服务")]), _vm._v(" "), _c('p', [_vm._v("提供最优质的综合生活与金融连接服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("深度合作")]), _vm._v(" "), _c('p', [_vm._v("与国内众多知名金融机构达成深度合作")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-coop"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNER")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("战略合作")])]), _vm._v(" "), _c('div', {
    staticClass: "dh-wa"
  }, [_c('div', {
    staticClass: "dw-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "dw-r"
  })]), _vm._v(" "), _c('p', {
    staticClass: "coop-text"
  }, [_vm._v("众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-partner"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "download-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫下载点点APP")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "wx-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫关注点点官微")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_vm._v("\n                Copyright © 2017 - 2018 Diandian 点点版权所有 粤ICP备17079095号-2\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-life"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("DIANDIAN")]), _vm._v(" "), _c('p', [_vm._v("点点")]), _vm._v(" "), _c('span', [_vm._v("让生活，好一点")])]), _vm._v(" "), _c('div', {
    staticClass: "hz-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-about"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', [_vm._v("关于点点")])]), _vm._v(" "), _c('div', {
    staticClass: "about-main"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("智能生活")]), _vm._v(" "), _c('p', [_vm._v("国内领先的智能生活金融服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("综合服务")]), _vm._v(" "), _c('p', [_vm._v("提供最优质的综合生活与金融连接服务")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ab-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("深度合作")]), _vm._v(" "), _c('p', [_vm._v("与国内众多知名金融机构达成深度合作")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-coop"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNER")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("战略合作")])]), _vm._v(" "), _c('div', {
    staticClass: "dh-wa"
  }, [_c('div', {
    staticClass: "dw-l"
  }), _vm._v(" "), _c('div', {
    staticClass: "dw-r"
  })]), _vm._v(" "), _c('p', {
    staticClass: "coop-text"
  }, [_vm._v("众安保险为点点的深度战略合作伙伴。众安（股票代码:HK06060）是由蚂蚁金服、腾讯与中国平安发起设立，并为点点用户提供全面账户信息安全保障服务。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-partner"
  }, [_c('div', {
    staticClass: "dh-title"
  }, [_c('strong', [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticClass: "partner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dh-footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "qrcode-box"
  }, [_c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "download-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫下载点点APP")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-download"
  }, [_c('div', {
    staticClass: "wx-qr-code"
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫关注点点官微")])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-text"
  }, [_c('p', [_vm._v("Copyright © 2017 - 2018 Diandian")]), _vm._v(" "), _c('p', [_vm._v("点点版权所有 粤ICP备17079095号-2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0e3b21"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = 232
// module chunks = 1